import React, { useEffect, useState } from "react";
import Modal from "../../components/common/Modal";
import { useAuctionDetail } from "../../components/common/AunctioneerDeteailProvider";
import EmailNotification from "./emailModal/EmailNotification";

function EmailNotificationModule({ open, setOpen }) {
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    roleCode,
    auction,
    auctionTypeMasterCode,
  } = useAuctionDetail();
  return (
    <div>
      {open && (
        <Modal
          title="Email Notification"
          show={open}
          handleClose={() => setOpen(false)}
          size="xl"
        >
          <EmailNotification handleClose={() => setOpen(false)} />
        </Modal>
      )}
    </div>
  );
}

export default EmailNotificationModule;
